import { useEffect } from "react";
import { useOptimizedAuthContext } from "@/contexts/OptimizedAuthContext";
import { Navigate } from "react-router-dom";

const LogOut = () => {
  const { signOut, isLoaded, isSignedIn } = useOptimizedAuthContext();
  useEffect(() => {
    if (isLoaded && isSignedIn) {
      void signOut();
    }
  }, [isLoaded, isSignedIn, signOut]);

  if (isLoaded && !isSignedIn) {
    return <Navigate to="/auth" replace />;
  }
  return null;
};

export default LogOut;
